export class Status {
    id: string = '';
    name: string = "";
    sequence: number = 0;
}